module.exports = __webpack_public_path__ + "img/analysis.db034280.png";